import mapboxgl from 'mapbox-gl'

// Production webpack/babel can break Mapbox's default blob worker (blank basemap,
// "n is not defined" in style expression parsing). Point at the CSP worker file
// copied into public/ by the copy-mapbox-worker npm script instead.
mapboxgl.workerUrl = `${process.env.PUBLIC_URL}/mapbox-gl-csp-worker.js`
